export enum Flipper {
  InsightsPortalAdsCampaign = 'insights_portal_ads_campaign',
  InsightsPortalAdsDashboard = 'rt_insights_portal_ads_dashboard',
  InsightsPortalAdsDashboardRetailers = 'rt_insights_portal_ads_dashboard_retailers',
  InsightsRedesignAndInfra = 'rt_insights_redesign_and_infra',
  InsightsRedesignMilestone2 = 'rt_insights_redesign_milestone_2',
  InsightsCampaignAnalytics = 'rt_insights_campaign_analytics',
  InsightsCampaignAnalyticsMilestone2 = 'rt_insights_campaign_analytics_milestone_2',
  InsightsCampaignGeographyMap = 'rt_insights_campaign_geography_map',
  InsightsCollectionsInsights = 'rt_insights_collections_insights',
  InsightsPlacementsInsights = 'rt_insights_placements_insights',

  // Clickhouse
  ClickhousePerformance = 'rt_insights_clickhouse_performance',
  ClickhouseOutOfStock = 'rt_insights_clickhouse_out_of_stock',
  ClickhouseBasket = 'rt_insights_clickhouse_basket',
  ClickhouseSearch = 'rt_insights_clickhouse_search',
  ClickhouseDataExplorer = 'insights_clickhouse_data_explorer',
  ClickhouseExecutiveSummary = 'rt_insights_clickhouse_executive_summary',

  // TODO: clean these up
  EmbedInsightsPortal = 'embed_insights_portal',
  ExtendedDateRangeOptions = 'insights_portal_extended_date_range',
  InsightsPortal = 'insights_portal',
  InsightsPortalDataExplorerPage = 'insights_portal_data_explorer',
  InsightsPortalSummaryReportPage = 'insights_portal_summary_report',
  InsightsStoreGroupFilter = 'insights_store_group_filter',

  // Connected Stores' Inventory Intelligence
  InsightsPortalInventoryIntelligence = 'rt_insights_portal_inventory_intelligence',
}
